import { doDelete, doGet, doPost, doPut } from "../../../api/baseAPI";
import { GROLOG_BASE_URL, GROLOG_URL } from "../../../constant/apiConstant"
import { setTableLoading } from "../../../store/reducer/page.reducer";
import { checkValidationToken } from "../../../util/errorHandler";


export const getList = async (token, refresh_token, page, limit, filter, order, CLIENT_ID, RESOURCE_USER_ID, dispatch) => {
  let result = { list: undefined, initiate: undefined, ok: false }
  const url = `${GROLOG_URL}/data-group`;
  const initiateUrl = `${GROLOG_URL}/data-group/initiate`;
  const params = { page, limit, filter, order, CLIENT_ID, RESOURCE_USER_ID }

  dispatch(setTableLoading(true));
  try {
    const response = await doGet(token, url, params)
    const initiateResponse = await doGet(token, initiateUrl, params)
    if (response && initiateResponse) {
      result.ok = true
      result.list = response.data.payload.data
      result.initiate = initiateResponse.data.payload.data
    }
  } catch (error) {
    checkValidationToken(error, token, refresh_token, dispatch)
  }

  dispatch(setTableLoading(false))
  return result
}

export const insert = async (token, refresh_token, data, params, dispatch) => {
  const result = { status: false, message: undefined }
  const url = `${GROLOG_URL}/data-group`

  try {
    const res = await doPost(url, token, data, params)
    if (res) {
      result.status = true
      result.message = res.data.payload.message
    } else {
      result.status = false
      result.message = res.data.payload.message
    }
  } catch (error) {
    result.message = error.response.data.payload.message
    checkValidationToken(error, token, refresh_token, dispatch)
  }

  return result
}

export const update = async (token, refresh_token, id, data, dispatch) => {
  const result = { status: false, message: undefined }
  const url = `${GROLOG_URL}/data-group/${id}`

  try {
    const res = await doPut(url, token, data)
    if (res) {
      result.status = true
      result.message = res.data.payload.message
    } else {
      result.status = false
      result.message = res.data.payload.message
    }
  } catch (error) {
    result.message = error.response.data.payload.message
    checkValidationToken(error, token, refresh_token, dispatch)
  }

  return result
}

export const getDetail = async (token, refresh_token, id, dispatch) => {
  const url = `${GROLOG_URL}/data-group/${id}`;
  let result = { data: undefined, ok: false }

  dispatch(setTableLoading(true))
  try {
    const response = await doGet(token, url, null);
    if (response) {
      result.ok = true;
      result.data = response?.data?.payload?.data
    }
  } catch (error) {
    checkValidationToken(error, token, refresh_token, dispatch)
  }
  dispatch(setTableLoading(false))
  return result
}

export const deleteItem = async (token, refresh_token, dispatch, data, params, id) => {
  let result = { item: undefined, ok: false, message: '' }
  const url = `${GROLOG_URL}/data-group/${id}`

  try {
    const response = await doDelete(url, token, data, params)
    if (response.data.payload.success) {
      result.ok = true
      result.item = response.data.payload.data
      result.message = response.data.payload.message
    } else {
      result.ok = false
    }
  } catch (error) {
    result.message = error.response.data.payload.message
    checkValidationToken(error, token, refresh_token, dispatch)
  }

  dispatch(setTableLoading(false))
  return result
}

export const getManagementHistoryList = async (token, refresh_token, dispatch, id) => {
  const url = `${GROLOG_BASE_URL}/audit/v1/grolog/audit?page=1&filter=table_name eq data_group, primary_key eq ${id}`;
  let result = { data: undefined, ok: false }

  try {
    const response = await doGet(token, url, null);
    if (response) {
      result.ok = true;
      result.data = response?.data?.payload
    }
  } catch (error) {
    checkValidationToken(error, token, refresh_token, dispatch)
  }
  return result
}

export const getDepotList = async (token, refresh_token, dispatch) => {
  const url = `${GROLOG_URL}/depot-configuration?page=1&limit=500&order=id asc`;
  let result = { data: undefined, ok: false }

  dispatch(setTableLoading(true))
  try {
      const response = await doGet(token, url, null);
      if (response) {
          result.ok = true;
          result.data = response?.data?.payload?.data
      }
  } catch (error) {
      checkValidationToken(error, token, refresh_token, dispatch)
  }
  dispatch(setTableLoading(false))
  return result
}